<template>
    <span class="channel-logo" :class="{'has-caption': !!caption}" :title="title">
        <BrandTileCmp :size="size" :image="markUrl" :icon="isCustom ? 'store-alt' : null"
            :text="brand.monogram" :background="brand.color" :color="brand.textColor" :muted="muted" />
        <span v-if="showName" class="channel-logo-text">
            <span class="channel-logo-name"><slot>{{label || channel.name || placeholder}}</slot></span>
            <small v-if="caption" class="channel-logo-caption">{{caption}}</small>
        </span>
    </span>
</template>

<script>
import { getChannelBrand } from '@/channel/models/ChannelBrand'
import { ChannelEnum } from '@c2b/muven-commons'
import BrandTileCmp from '@/utils/components/BrandTileCmp.vue'

export default {
    name: 'ChannelLogoCmp',
    components: {
        BrandTileCmp,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
        size: {
            type: Number,
            default: 22,
        },
        showName: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: '-',
        },
        // Texto principal no lugar do channel.name (ex.: nome real do canal).
        label: {
            type: String,
            default: '',
        },
        // Segunda linha, menor (ex.: nome personalizado).
        caption: {
            type: String,
            default: '',
        },
        // Opção desaconselhada: o tile perde força para não competir com as demais.
        muted: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        brand() {
            return getChannelBrand(this.channel.enumChannel)
        },
        isCustom() {
            return this.channel.enumChannel === ChannelEnum.Custom
        },
        markUrl() {
            return this.brand.mark ? require(`@/channel/images/marks/${this.brand.mark}`) : null
        },
        title() {
            if (!this.showName) {
                return this.label || this.channel.name
            }

            // Só vale a pena quando o nome exibido é o personalizado; com label ou
            // caption o nome real já está na tela.
            if (!this.label && !this.caption && this.channel.hasCustomizedName && this.channel.hasCustomizedName()) {
                return this.channel.getRealName()
            }

            return null
        },
    },
}
</script>

<style lang="scss" scoped>
.channel-logo {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    vertical-align: middle;
}

.channel-logo-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.channel-logo-caption {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--text-muted);
    // Em títulos de card o pai é negrito; o nome secundário não deve ser.
    font-weight: 400;
    line-height: 1.2;
}

.has-caption .channel-logo-name {
    line-height: 1.25;
}

.channel-logo-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
